import { useAppSearch } from "_graphql/cache/auth";
import { Modal } from "components";
import PointRedemptionView from "components/cards/point-redemption-view";
import { usePointRedemptionUsage } from "hooks/data/use-point-redemptions";

export default function ViewPointRedemptionContainer({
  open,
  setOpen,
}: {
  open: boolean;
  setOpen: (val: boolean) => void;
}) {
  const searchParams = useAppSearch();
  const { loading, redemption } = usePointRedemptionUsage({
    redemptionId: searchParams?.id || "",
  });

  return (
    <Modal
      open={open}
      setOpen={setOpen}
      loading={loading}
      title="View Redemption Details"
      description="Details of the point redemption are shown below"
    >
      <PointRedemptionView redemption={redemption} />
    </Modal>
  );
}
